import { useContext } from 'react'

import { PassContext } from "../../pass-context"
import dataSelector from '../data-selector'
import PopupEditor2 from "../popup-editor"

const vaildPassTypes = ["boardingPass", "coupon", "eventTicket", "generic","storeCard"]

const DescriptionAndUpdateLog = ({ show }) => {

  const { template, instanceData, scannerInstanceData, passType } = useContext(PassContext)

  if (show) {

    const description = dataSelector({ template, instanceData, scannerInstanceData, path: "meta.description" })

    return (
      <div className="updateInfo">
        {vaildPassTypes.includes(passType) &&
          <PopupEditor2 title="Pass Description" path="meta.description" colors={{ description: "Black (fixed)" }}>
            <div className="header editable">
              {description}
            </div>
          </PopupEditor2>
        }
        <div>Updated just now</div>
      </div>
    )
  }
}

export default DescriptionAndUpdateLog